
<form class="mb-1" #paramsForm="ngForm">
  <div class="d-flex flex-wrap align-items-center mt-1">              
    <button class="px-1 py-0 btn"
    [ngClass]="volunteerTaskPoint.targetCallCnt!=null?'font-weight-bold btn-outline-primary':'btn-outline-secondary'"
      *ngIf="!targetCallCnt.bEditing; else editingTargetCallCntTmpl"
      (click)="targetCallCnt.beginEdit()"
      (contextmenu)="useDefaultValue(targetCallCnt);false;">
      {{targetCallCnt.value||0}}
    </button>
    <ng-template #editingTargetCallCntTmpl>
      <div class="d-flex flex-row flex-shrink-1 align-items-center">
        <input type="text" class="m-0 p-1" name="targetCallCnt" autofocus
          [ngStyle]="{width:'3em'}"
          (keyup.enter)="onSaveInlineEdit(targetCallCnt)"
          (contextmenu)="useDefaultValue(targetCallCnt);false;"
          [(ngModel)]="targetCallCnt.value" #targetCallCntInput="ngModel">
        <span *ngIf="!bFormMode" class="ml-1 text-nowrap">
        <i *ngIf="targetCallCntInput.dirty" title="Save call count"
          class="text-primary fa fa-save p-1 mx-1 border" role="button"
          (click)="onSaveInlineEdit(targetCallCnt)"></i>
        <i title="Cancel" class="text-danger fa fa-times p-1 mx-1 border" role="button" 
          (click)="targetCallCnt.reset()"></i>
        </span>
      </div>
      <div *ngIf="targetCallCnt.errorMsg" class="text-danger font-italic font-weight-bold">
        {{targetCallCnt.errorMsg}}
      </div>
    </ng-template>
    &nbsp;calls to&nbsp;
    <button class="px-1 py-0 btn" 
      [ngClass]="volunteerTaskPoint.dialNumber?'font-weight-bold btn-outline-primary':'btn-outline-secondary'"
      *ngIf="!dialNumber.bEditing; else editingDialNumberTmpl"
      (click)="dialNumber.beginEdit()"
      (contextmenu)="useDefaultValue(dialNumber);false;">
      {{dialNumber.value||'-'}}
    </button>
    <ng-template #editingDialNumberTmpl>
      <div class="d-flex flex-row flex-shrink-1 align-items-center">
        <input type="text" class="m-0 p-1" name="dialNumber" autofocus
          [ngStyle]="{width:'8em'}"
          (keyup.enter)="onSaveInlineEdit(dialNumber)"
          (contextmenu)="useDefaultValue(dialNumber);false;"
          [(ngModel)]="dialNumber.value" #dialNumberInput="ngModel">
        <span *ngIf="!bFormMode" class="ml-1 text-nowrap">
        <i *ngIf="dialNumberInput.dirty" title="Save call count"
          class="text-primary fa fa-save p-1 mx-1 border" role="button"
          (click)="onSaveInlineEdit(dialNumber)"></i>
        <i title="Cancel" class="text-danger fa fa-times p-1 mx-1 border" role="button" 
          (click)="dialNumber.reset()"></i>
        </span>
      </div>
      <div *ngIf="dialNumber.errorMsg" class="text-danger font-italic font-weight-bold">
        {{dialNumber.errorMsg}}
      </div>
    </ng-template>&nbsp;for&nbsp;

    <button class="px-1 py-0 btn" 
    [ngClass]="volunteerTaskPoint.targetCallDurationSecs!=null?'font-weight-bold btn-outline-primary':'btn-outline-secondary'"
      *ngIf="!targetCallDurationSecs.bEditing; else editingTargetCallDurationSecsTmpl"
      (click)="targetCallDurationSecs.beginEdit()"
      (contextmenu)="useDefaultValue(targetCallDurationSecs);false;">
      {{targetCallDurationSecs.value||0}}
    </button>
    <ng-template #editingTargetCallDurationSecsTmpl>
      <div class="d-flex flex-row mr-1 flex-shrink-1 align-items-center">
        <input type="text" class="m-0 p-1" name="targetCallDurationSecs" autofocus
          [ngStyle]="{width:'3em'}"
          (keyup.enter)="onSaveInlineEdit(targetCallDurationSecs)"
          (contextmenu)="useDefaultValue(targetCallDurationSecs);false;"
          [(ngModel)]="targetCallDurationSecs.value" #targetCallDurationSecsInput="ngModel">
        <span *ngIf="!bFormMode" class="ml-1 text-nowrap">
        <i *ngIf="targetCallDurationSecsInput.dirty" title="Save call duration"
          class="text-primary fa fa-save p-1 mx-1 border" role="button"
          (click)="onSaveInlineEdit(targetCallDurationSecs)"></i>
        <i title="Cancel" class="text-danger fa fa-times p-1 mx-1 border" role="button" 
          (click)="targetCallDurationSecs.reset()"></i>
        </span>
      </div>
      <div *ngIf="targetCallDurationSecs.errorMsg" class="text-danger font-italic font-weight-bold">
        {{targetCallDurationSecs.errorMsg}}
      </div>
    </ng-template>&nbsp;seconds and&nbsp;

    <ng-container *ngIf="!callIntervalSecs.bEditing; else editingCallIntervalSecsTmpl">
    <button class="px-1 py-0 btn" 
      [ngClass]="volunteerTaskPoint.callIntervalSecs!=null?'font-weight-bold btn-outline-primary':'btn-outline-secondary'"                 
      (click)="callIntervalSecs.beginEdit()"
      (contextmenu)="useDefaultValue(callIntervalSecs);false;">
      {{(callIntervalSecs.value||0)/60.0|number:'1.0-2'}}
    </button>
    &nbsp;minutes apart
    </ng-container>
    <ng-template #editingCallIntervalSecsTmpl>
      <div class="d-flex flex-row mr-1 flex-shrink-1 align-items-center">
        <input type="text" class="m-0 p-1" name="callIntervalSecs" autofocus
          [ngStyle]="{width:'5em'}"
          (keyup.enter)="onSaveInlineEdit(callIntervalSecs)"
          (contextmenu)="useDefaultValue(callIntervalSecs);false;"
          [(ngModel)]="callIntervalSecs.value" #callIntervalSecsInput="ngModel">
        <span *ngIf="!bFormMode" class="ml-1 text-nowrap">
        <i *ngIf="callIntervalSecsInput.dirty" title="Save call interval"
          class="text-primary fa fa-save p-1 mx-1 border" role="button"
          (click)="onSaveInlineEdit(callIntervalSecs)"></i>
        <i title="Cancel" class="text-danger fa fa-times p-1 mx-1 border" role="button" 
          (click)="callIntervalSecs.reset()"></i>
        </span>&nbsp;seconds apart
      </div>
      <div *ngIf="callIntervalSecs.errorMsg" class="text-danger font-italic font-weight-bold">
        {{callIntervalSecs.errorMsg}}
      </div>
    </ng-template>
  </div>


  <div class="d-flex flex-wrap align-items-center justify-content-start mt-1">
    <div class="font-italic pr-1">Location Validation</div>
    <div class="d-flex flex-wrap justify-content-start">
      <div class="card mr-1 d-flex flex-row align-items-center">
        <span class="p-1 mr-2 text-secondary font-italic small">BEFORE</span>
        <label class="form-check-inline my-0" (contextmenu)="useDefaultValue(qrValidationRequired);false;">                    
          <input type="checkbox" name="qrValidationRequired" [(ngModel)]="qrValidationRequired.value"                         
              (change)="onSaveInlineEdit(qrValidationRequired,$event.target)">
          <span class="ml-1" [ngClass]="volunteerTaskPoint.qrValidationRequired==null?'text-secondary':'font-weight-bold text-primary'"
          >QR Scan</span>
        </label>
        <label class="form-check-inline my-0" (contextmenu)="useDefaultValue(photoValidationRequired);false;">
          <input type="checkbox" name="photoValidationRequired" [(ngModel)]="photoValidationRequired.value"
              (change)="onSaveInlineEdit(photoValidationRequired,$event.target)">
          <span class="ml-1" [ngClass]="volunteerTaskPoint.photoValidationRequired==null?'text-secondary':'font-weight-bold text-primary'"
          >Photo(s)</span>
        </label>
      </div>
      <div class="card d-flex flex-row align-items-center">
        <span class="p-1 mr-2 text-secondary font-italic small">AFTER</span>
        <label class="form-check-inline my-0" 
          (contextmenu)="useDefaultValue(computeFixValidationRequired);false;"
          title="Compute location after each call using the location API of handset">
          <input type="checkbox" name="computeFixValidationRequired" [(ngModel)]="computeFixValidationRequired.value" 
              (change)="onSaveInlineEdit(computeFixValidationRequired,$event.target)">
          <span class="ml-1" [ngClass]="volunteerTaskPoint.computeFixValidationRequired==null?'text-secondary':'font-weight-bold text-primary'"
          >OS API</span>
        </label>
      </div>
    </div>
    <div *ngIf="saveTaskPointErrorMsg" class="text-danger font-italic font-weight-bold">
      {{saveTaskPointErrorMsg}}
    </div>
  </div>

</form>
